<template>
	<div class="tw-flex tw-justify-between tw-items-center">
		<div class="tw-flex uppercase">
			<img :src="factorImage" alt='' class="tw-mr-4">
			<h3 class="tw-m-0 text-info">{{ factorName }}</h3>
		</div>
		<div>
			<v-slider
				class="score-slider tw-w-60"
				height="3"
				hide-details
				v-model="weighingAssignation"
				:tick-labels="ticksLabels"
				:max="2"
				step="1"
				ticks="always"
				tick-size="5"
				@change="onSliderChange"
			></v-slider>
		</div>
	</div>
</template>

<script>
import { prop } from 'ramda';

export default {
	name: 'WeighingFactorSlider',
	props: ['factorName', 'factorImage'],
	data() {
		return {
			ticksLabels: [0.25, 0.50, 0.75],
			weighingAssignation: 0,
		};
	},
	mounted() {
		this.emitAssignation();
	},
	methods: {
		onSliderChange() {
			this.$emit('sliderInteraction');
		},
		reset() {
			this.weighingAssignation = 0;
		},
		emitAssignation() {
			const factorAssign = prop(this.weighingAssignation, this.ticksLabels);
			this.$emit('weighingAssignationChange', {
				factorAssign,
				comparedFactorAssign: 1 - factorAssign,
			});
		},
	},
	watch: {
		weighingAssignation: {
			handler() {
				this.emitAssignation();
			},
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorSlider.vue